import jQuery from 'jquery';
import jQueryUi from 'jquery-ui';
import {widget as overlayWidget} from './overlay-widget';
import {trackingService} from "../tracking/services/tracking";

const widget = jQuery.widget('ep.cookieConsentOverlayWidget', overlayWidget, {
    options: {
        classes: {
            buttonsSection: 'overlay-widget__buttons-section',
            'description': 'overlay-widget__description content',
            button: 'overlay-widget__button',
            acceptButton: 'overlay-widget__button--type-accept',
            denyButton: 'overlay-widget__button--type-deny',
            widgetExtraClasses: ['overlay-widget--subtype-cookie-consent'],
        },
        cookieInformation: '',
        cookieName: 'invalid',
        texts: {
            acceptButton: __('cookieconsentoverlay.btn.activate'),
            denyButton: __('cookieconsentoverlay.btn.deny'),
        }
    },
    _create: function(){
        const options = this.options;
        const classes = options.classes;
        const texts = options.texts;

        const buttonsSection = '<div class="' + classes.buttonsSection + '">' +
            '<button type="button" class="' + classes.button + ' ' + classes.acceptButton + '">' + texts.acceptButton + '</button> ' +
            '<button type="button" class="' + classes.button + ' ' + classes.denyButton + '">' + texts.denyButton + '</button>' +
            '</div>';

        this.options.content = '<div class="' + classes.description + '">' + this.options.cookieInformation + buttonsSection + '</div>';

        this._super();

        this._on(this.element.find('.' + classes.acceptButton), {
           click: () => {
               trackingService.accept(options.cookieName);
               this.close();
           }
        });

        this._on(this.element.find('.' + classes.denyButton), {
            click: () => {
                this.close();
            }
        });
    }
});

export {widget as widget};

export default function(){
    // Nothing to initialize
}
